<style lang="scss">
.slide-24 {
  background-image: url(../../../assets/module1/slide24/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-left: 85px;
  padding-right: 115px;
  padding-top: 45px;
  height: calc(100% - 45px);

  h1 {
    font-size: 120px;
    color: #c5d43b;
    margin-bottom: 50px;
    span {
      transform: rotate(-11deg) translateY(-110px);
      display: block;
      &:last-of-type {
        font-size: 64px;
        transform: rotate(-3deg) translate(97px, -22px);
      }
    }
  }
  h2 {
    font-size: 84px;
    color: #f8dc61;
    margin-left: 50px;
    position: relative;
    z-index: 1;
  }
  p {
    color: white;
    margin-left: 50px;
    &:first-of-type {
      margin-bottom: 10px;
    }
  }
  .para {
    &-left {
      max-width: 365px;
      margin-top: 53px;
      margin-left: 128px;
    }
    &-right {
      position: absolute;
      right: 58px;
      left: auto;
      max-width: 790px;
    }
  }
  .second-para {
    max-width: 356px;
    position: absolute;
    right: 580px;
    bottom: 202px;
  }
  .btn {
    transition: all 0.2s ease-out;
    display: block;
    width: 155px;
    position: absolute;
    left: 718px;
    bottom: 34px;
    z-index: 9;
    &-download {
      right: 25px;
      bottom: 536px;
      left: auto;
      width: 190px;
    }
    &:hover {
      transform: scale(1.1);
    }
  }
  #mainCanvas {
    position: absolute;
    bottom: 21px;
    height: 560px;
    left: 610px;
    z-index: 1;
  }
  .c2 {
    position: absolute;
    z-index: 2;
    left: 630px;
    bottom: 60px;
    transform: scale(0.445);
    transform-origin: 0% 50%;
  }
  .crop-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1.5);
    z-index: 99;
    box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.75);
  }
}
.hidden {
  display: none;
}
</style>

<template>
  <div class="slide-24">
    <ImageCropper
      src="@/assets/module1/slide24/time.png"
      id="cropper"
      ref="cropper"
      :cropAspectRatio="1 / 1.15"
      class="hidden crop-wrap"
      v-on:childToParent="onChildClick"
    />
    <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 23"
        src="@/assets/module1/slide24/timmy-01.png"
        class="chars"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 23"
        src="@/assets/module1/slide24/poster-06.png"
        class="chars delay-4"
      />
    </transition>
    <transition name="fadeUp" appear>
      <canvas id="mainCanvas" ref="canvas" width="400" height="600"></canvas>
    </transition>
    <transition name="scale" appear>
      <h1
        class="delay-1"
        v-show="slideIndex == 23"
        v-html="$t('module1.slide24.heading')"
      ></h1>
    </transition>
    <transition name="fadeUp" appear>
      <div class="delay-2" v-show="slideIndex == 23">
        <p class="para-intro">{{ $t("module1.slide24.paragraph") }}</p>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <h2 class="delay-3" v-show="slideIndex == 23">
        {{ $t("module1.slide24.heading2") }}
      </h2>
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 23" class="delay-5">
        <p class="para-left">{{ $t("module1.slide24.paragraph2") }}</p>
      </div>
    </transition>
    <transition name="fade" appear>
      <div v-show="slideIndex == 23" class="delay-8">
        <p class="para-right">{{ $t("module1.slide24.paragraph3") }}</p>
      </div>
    </transition>
    <transition name="scale" appear>
      <a
        v-show="slideIndex == 23"
        class="btn btn-download duration-1 delay-6"
        :href="pdfLink"
        target="_blank"
        ><img src="@/assets/module1/slide24/download.png"
      /></a>
    </transition>
    <transition name="scale" appear>
      <a
        v-show="slideIndex == 23"
        class="btn duration-1 delay-9"
        @click="uploadAreaClick"
        ref="uploadArea"
        target="_blank"
      >
        <img src="@/assets/module1/slide24/upload.png" v-show="!uploaded" />
        <img
          src="@/assets/module1/slide23/download_btn.svg"
          v-show="uploaded"
        />
      </a>
    </transition>
    <canvas ref="canvas2" width="750" height="450" class="c2 hidden"></canvas>
    <div class="hidden">
      <img
        ref="flatimage"
        src=""
        alt=""
        class="hidden"
        width="400"
        height="600"
        style="width: unset;"
      />
      <input type="file" ref="file" accept="image/*" @change="updateImage" />
    </div>
  </div>
</template>

<script>
import ImageCropper from "@/components/ImageCropper.vue";
const frame = require("@/assets/module1/slide24/image_frame.svg");
const time = require("@/assets/module1/slide24/time.png");
/** @type ?CanvasRenderingContext2D */
let ctx = null;
let ctx2 = null;

async function loadImage(image) {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      resolve(img);
    };
    img.src = image;
  });
}

export default {
  name: "Slide24",
  props: {
    slideIndex: { type: Number },
    imageBlob: { type: String, default: undefined },
    imageId: { type: String, default: "0" }
  },
  components: {
    ImageCropper
  },
  data() {
    return {
      counter: 0,
      fromChild: "", // This value is set to the value emitted by the child
      uploaded: false,
      pdfLink:
        window?.CF_EBOOK_VARS?.documents?.book_1_document_2?.url ||
        "../Mask.pdf"
    };
  },
  methods: {
    updateImage(e) {
      const image = new Image();

      image.onload = () => {
        // ctx2.clip();
        const cw = ctx2.canvas.width;
        const ch = ctx2.canvas.height;
        ctx2.save();
        ctx2.translate(cw / 1.5, ch / 2.195);
        ctx2.rotate((-10 * Math.PI) / 180);
        ctx2.translate(-cw / 1.5, -ch / 2.195);
        ctx2.scale(1, 1.15);

        ctx2.beginPath();

        ctx2.arc(cw / 1.5, ch / 2.195, cw / 10, 0, Math.PI * 2, true);

        ctx2.closePath();
        ctx2.scale(1, 0.8695652173913043);

        ctx2.clip();
        ctx2.drawImage(
          image,
          0,
          0,
          image.width,
          image.height,
          cw / 1.765,
          ch / 3,
          cw / 5,
          ch / 2.6
        );

        ctx2.restore();
        ctx2.rotate((-10 * Math.PI) / 180);
        ctx2.restore();

        const flat = this.$refs.flatimage;
        flat.src = ctx2.canvas.toDataURL("image/png");
        flat.classList.remove("hidden");
        ctx2.canvas.classList.remove("hidden");
        const download = this.$refs.uploadArea;

        if (ctx2.canvas.msToBlob) {
          //for IE
          var blob = ctx2.canvas.msToBlob();
          window.navigator.msSaveBlob(blob, "fast-heroes-mask.jpg");
        } else {
          //other browsers
          download.href = ctx2.canvas.toDataURL();
          download.download = "fast-heroes-mask.jpg";
          download.classList.remove("hidden");
        }

        this.uploaded = true;
      };

      image.src = e;
    },

    uploadAreaClick(e) {
      if (!this.uploaded) {
        e.preventDefault();
        this.uploadImage(e);
      }
    },

    uploadImage() {
      const cropper = document.getElementById("cropper");
      this.$refs.cropper.showFileChooser();
      cropper.classList.remove("hidden");
    },
    onChildClick(value) {
      const cropper = document.getElementById("cropper");
      this.fromChild = value;
      cropper.classList.add("hidden");
      this.updateImage(this.fromChild);
    }
  },
  watch: {
    slideIndex(val) {
      if (val !== 23) return;

      Promise.all([
        new Promise(resolve => {
          const el = this.$refs.canvas;
          ctx = el.getContext("2d");
          loadImage(frame).then(i => {
            ctx.drawImage(i, 0, 0, 400, 600);
            resolve();
          });
        }),
        new Promise(resolve => {
          const el = this.$refs.canvas2;
          ctx2 = el.getContext("2d");
          loadImage(time).then(i => {
            ctx2.drawImage(i, 0, 0, ctx2.canvas.width, ctx2.canvas.height);
            resolve();
            console.log(this.$refs.canvas2);
          });
        })
      ]);
    }
  }
};
</script>
